import '../../styles/game/GameRules.css';
import '../../styles/game/ProvablyFairSettings.css';
import '../../styles/game/FairnessModal.css';
import { useTranslation } from "react-i18next";
import { useEffect, useState } from 'react';
import ProvablyFair from './ProvablyFair.jsx'
import { t } from "i18next";


function FairnessModal({ isOpen, onClose, roundId }) {
    const [isVisible, setIsVisible] = useState(false);
    const { t } = useTranslation();
    const [roundInfo, setRoundInfo] = useState({})
    const [isProvablyOpen, setIsProvablyOpen] = useState(false);
    const [color, setColor] = useState("rgb(52, 180, 255)")

    



    useEffect(() => {

        const getRoundInfo = async (roundId) => {
            try {
                const response = await fetch(`${import.meta.env.VITE_API_URL}/api/round-info`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ roundId: roundId })
                });
    
                if (!response.ok) {
                    throw new Error(`Ошибка HTTP: ${response.status}`);
                }
    
                if (response.ok) {
                    const result = await response.json();
                    // console.log(result.result)
                    setRoundInfo(result.result)
                }
    
            } catch (error) {
                console.log(error)
            }
        }
        if (roundId) {
            getRoundInfo(roundId); // Передаем обновленный roundId
            
        }
    }, [roundId])

    useEffect(() => {
        if(roundInfo) {
            const result = parseFloat(roundInfo.roundResult)
            if (result >= 2 && result < 10) {
                setColor("rgb(145, 62, 248)")
            } else if (result >= 10) {
                setColor("rgb(192, 23, 180)")
            } else if (result < 2.0) {
                setColor("rgb(52, 180, 255)")
            }
        }
    }, [roundInfo])
    
    const closeProvably = () => {
        setTimeout(() => {
            setIsProvablyOpen(false)
        }, 200)
    }


    useEffect(() => {
        if (isOpen) {
            setTimeout(() => setIsVisible(true), 10);
        } else {
            setIsVisible(false);
        }
    }, [isOpen]);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                setTimeout(() => setIsVisible(false), 10);
                onClose();
            }
        };

        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, []);

    function getRoundTime() {
        const [datePart, timePart] = roundInfo.createdAt.split('T');
        const timeParts = timePart.split('.')
        return timeParts[0]
    }


    return (
        <>
            <div className={`modalWrapper ${isVisible ? "show" : "fade-out"}`}
                 onClick={() => {
                     setTimeout(() => setIsVisible(false), 10);
                     onClose();
                 }}>
            </div>
            <div className={`gameRulesModal ${isVisible ? "show" : "fade-out"}`} onClick={() => {
                setTimeout(() => setIsVisible(false), 10);
                onClose();
            }}>
                <div className={`provablyFairSettings ${isVisible ? "show" : "fade"}`}>
                    <div className={'gameRulesContent'} onClick={(e) => e.stopPropagation()}>
                        <div className={'gameRulesHeader'}>
                            <span>ROUND {roundInfo.id}</span>
                            <div className={'fairness-round-info-wrapper'}>
                                <div className={'fairness-round-multiplier'} style={{color}}>
                                    {roundInfo.roundResult}x
                                </div>
                                <div className={'fairness-round-date'}>{roundInfo.createdAt ? getRoundTime() : ""}</div>
                            </div>
                            <button className={'gameRulesCloseBtn'} onClick={() => {
                                setTimeout(() => setIsVisible(false), 10);
                                onClose();
                            }}>
                                <span>×</span>
                            </button>
                        </div>
                        
                        <div className={'fairness-modal-body'}>
                            <div className={'fairness-modal-body-content-wrapper'}>
                                <div className={'fairness-modal-body-content'}>
                                    <div className={'fairness-modal-content-part'}>
                                        <div className={'fairness-server-seed'}>
                                            <div className={'fairness-server-seed-icon'}></div>
                                            <div className={'fairness-server-seed-text'}>
                                                <span>Server seed:</span>
                                                <div> Generated on our side </div>
                                            </div>
                                        </div>
                                        <div className={'fairness-modal-server-seed-value'}>
                                            <input type="text" value={roundInfo.serverSeed} />
                                        </div>
                                    </div>
                                    <div className='fairness-modal-content-part pt-20'>
                                        <div className={'fairness-server-seed'}>
                                        <div className={'fairness-client-seed-icon'}></div>
                                            <div className={'fairness-server-seed-text'}>
                                                <span>Client seed:</span>
                                                <div> Generated on player side </div>
                                            </div>
                                        </div>
                                        <div className={'fairness-modal-server-seed-value mb-5 client'}>
                                            <div className={'fairness-player-wrap'}>
                                                <span>Player N3:</span>
                                                <div className={'fairness-player-info'}>
                                                    <img src={roundInfo.firstClientAvatar} alt="" />
                                                    {roundInfo.firstClientId}
                                                </div>
                                                

                                            </div>
                                            <div className={'fairness-player-seed'}>
                                            <span>Seed:</span>
                                                    <div>{roundInfo.firstClientSeed}</div>
                                            </div>
                                            
                                        </div>
                                        <div className={'fairness-modal-server-seed-value mb-5 client'}>
                                            <div className={'fairness-player-wrap'}>
                                                <span>Player N3:</span>
                                                <div className={'fairness-player-info'}>
                                                    <img src={roundInfo.secondClientAvatar} alt="" />
                                                    {roundInfo.secondClientId}
                                                </div>
                                                

                                            </div>
                                            <div className={'fairness-player-seed'}>
                                            <span>Seed:</span>
                                                    <div>{roundInfo.secondClientSeed}</div>
                                            </div>
                                            
                                        </div>
                                        <div className={'fairness-modal-server-seed-value mb-5 client'}>
                                            <div className={'fairness-player-wrap'}>
                                                <span>Player N3:</span>
                                                <div className={'fairness-player-info'}>
                                                    <img src={roundInfo.thirdClientAvatar} alt="" />
                                                    {roundInfo.thirdClientId}
                                                </div>
                                                

                                            </div>
                                            <div className={'fairness-player-seed'}>
                                            <span>Seed:</span>
                                                    <div>{roundInfo.thirdClientSeed}</div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                    <div className={'fairness-modal-content-part pt-20'}>
                                    <div className={'fairness-server-seed'}>
                                            <div className={'fairness-server-seed-icon hash'}></div>
                                            <div className={'fairness-server-seed-text'}>
                                                <span>Combined SHA512 Hash:</span>
                                                <div>  Above seeds combined and converted to SHA512 Hash. This is your game result  </div>
                                            </div>
                                            
                                        </div>
                                        <div className={'fairness-modal-server-seed-value'}>
                                            <input type="text" value={roundInfo.combinedHash} />
                                        </div>
                                    </div>
                                    <div className={'fairness-modal-content-part pt-20 row'}>
                                        <div className={'footer-parts-title'}>
                                            <span>Hex:</span>
                                            <span>Decimal:</span>
                                            <span>Result:</span>
                                        </div>
                                        <div className={'footer-parts-value'}>
                                            <span>{roundInfo.hex}</span>
                                            <span>{roundInfo.decimal}</span>
                                            <span>{roundInfo.roundResult}</span>
                                        </div>
                                    </div>
                                    <div className={'fairness-modal-content-part pt-20 column'}>
                                        <div className={'footer-part-title'}>Hex:</div>
                                        <div className={'footer-part-value'}>{roundInfo.hex}</div>
                                        <div className={'footer-part-title'}>Decimal:</div>
                                        <div className={'footer-part-value'}>{roundInfo.decimal}</div>
                                        <div className={'footer-part-title'}>Result:</div>
                                        <div className={'footer-part-value'}>{roundInfo.roundResult}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={'provablyFairSettingsFooter fairness'}>
                            <div className={'fairness-footer'}>
                            For instructions check 
                            <span onClick={() => setIsProvablyOpen(true)}> What is Provably Fair </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isProvablyOpen && <ProvablyFair isOpen={isProvablyOpen} onClose={closeProvably} ProvablyOpen={() => setIsProvablyOpen(true)} />}
        </>
    )
}

export default FairnessModal;